define('utils',[
	"jquery",
	"underscore",
	"underscore-string",
	"moment",
	"localizationService",
],

function($, _, _S, Moment, LocalizationService) {

	var Utils = {
		/**
		 * Gets the side by side view document from the repository when the user enables side by side view.
		 * @global
		 */

		//TODO: How should we handle the fact that we need to call setDocumentInfo from Context and call multiple triggers off of OAEvents??
		getCompareDocument: function(id, lastModified, maxDocumentSize, Context, OAEvents, Config) {
			// We only want to retrieve this document once.
			$.ajax({
				url: $.cookie("openannotate.clientRequestUrl") + "/annotation/getDocumentInfo",
				dataType: "json",
				method: "GET",
				data: { 
					id: id,
					requestUrl: $.cookie("openannotate.clientRequestUrl"),
					lastModified: lastModified,
					maxDocumentSize: maxDocumentSize,
					sizeOfLargeFiles: Config.sizeOfLargeFiles
				},
				success: function(data) {
					// Context.setDocumentInfo(data);
					// var sbsDocumentInfo = data;

					// if (!sbsDocumentInfo.sameVersion) {

					// 	SessionInfo.docId.push(sbsDocumentInfo.pages[0].pageId);
					
					// 	// Loop over each of the pages and add the docId to that page.
					// 	_.each(sbsDocumentInfo.pages, function(page) {
					// 		page.docId = sbsDocumentInfo.pages[0].pageId;
					// 	});

					// 	Context.setDocumentInfo(sbsDocumentInfo.totalPages, sbsDocumentInfo);

					   OAEvents.trigger("finishedRetrievingCompareDoc", data);
					// } else {
					// 	// If we compared the same document version, alert the user and don't do anything.
					// 	OAEvents.trigger("sameVersionCompareDocs");
					// }
				},

				// Called when an error occurs loading the document information.
				error: function() {
					// Trigger an event that we failed to load the document information.
					OAEvents.trigger("errorLoadingCompareDocument");
				}

			});
		},

		/**
		 * Generates random bits of a string so we can create a unique identifier for our annotation to create.
		 * @returns {string} - A random string of digits and leters.
		 */
		_S4: function() {
			return (((1 + Math.random()) * 0x10000)|0).toString(16).substring(1);
		},

		/**
		 * Generates a random client side ID for an annotation.
		 * @returns {string} - A unique client side ID for an annotation.
		 */
		_generateGuid: function() {
			return (this._S4() + this._S4() + "-" + this._S4() + "-" + this._S4() + "-" + this._S4() + "-" + this._S4() + this._S4() + this._S4());
		},

		/**
		 * Returns browser independent values for offsetX and offsetY for a jQuery event object. There was a jQuery
		 * bug with Firefox where the native jQuery event offset values were not properly populated. See
		 * http://bugs.jquery.com/ticket/8523#comment:14 for the jQuery bug and 
		 * http://stackoverflow.com/questions/11334452/event-offsetx-in-firefox for the fix.
		 * @global
		 * @param {Object} event - A jQuery event object to find the browser independent values of offsetX and offsetY.
		 * @param {Object} [options] - An object containing various optional parameters. 
		 * @param {Object} [options.relativeToElement] - If we want the coordinates to be given relative to a 
		 * certain element then this is the element the offset is relative to.
		 * @returns {Object} - An object containing the "offsetX" and "offsetY" values properly calculated for
		 * cross-browser compatability.
		 */
		getMouseEventOffset: function(event, options) {	
			if(event.originalEvent && event.originalEvent.changedTouches) {
				var canvasOffsetLeft = 0;
				var canvasOffsetTop = 0;

				if(options && options.textView) {
					var canvas = options.textView.raphaelCanvas.canvas;
					var canvasOffset = $(canvas).offset();
					canvasOffsetLeft = canvasOffset.left;
					canvasOffsetTop = canvasOffset.top;
				}
				
				return {
					offsetX: event.originalEvent.changedTouches[0].pageX - $(document).scrollLeft() - canvasOffsetLeft,
					offsetY: event.originalEvent.changedTouches[0].pageY - $(document).scrollTop() - canvasOffsetTop
				};
			} else {
				return {
					offsetX: (event.offsetX || event.pageX - $(event.target).offset().left),
					offsetY: (event.offsetY || event.pageY - $(event.target).offset().top)
				};
			}
		},

		/**
		 * Returns the top offset of the passed in element. This is useful for getting the top of
		 * a page when the pages element has been scrolled.
		 * @param {Object} element - The DOM element to get the top offset of (this is NOT a jQuery
		 * wrapped object).
		 * @returns {number} - The top offset of the passed in element, relative to its offset parent.
		 */
		getOffsetTopOfElement: function(element) {
			return element.offsetTop + element.clientTop;
		},

		/**
		 * Updates the parameters in the OpenAnnotate URL based on the microStateKey passed in.
		 * @global
		 * @param {string} microStateKey - The parameter in the URL we want to update
		 * @param {string} value - The value we want to use for the parameter we are updating
		 */
		updateUrlMicrostate: function(microStateKey, value) {
			var windowSearchVal = window.location.search;
			var regex = new RegExp("([&]*" + microStateKey + "=(.*?))([^&]+)");

			// If we don't have a value being passed in, then remove the parameter from the URL.
			if (!value) {
				windowSearchVal = windowSearchVal.replace(regex, "");
			} else {
				// Check to see if the microstate key exists in the URL.
				if (regex.test(windowSearchVal)) {
					// Update the URL parameter.
					windowSearchVal = windowSearchVal.replace(regex, "&" + microStateKey + "=" + encodeURIComponent(value));
				} else {
					// Add the parameter to the browser URL.
					windowSearchVal += "&" + microStateKey + "=" + encodeURIComponent(value);
				}
			}

			// URI encode
			// Update the browser URL
			window.history.pushState('page1', 'OpenAnnotate', window.location.pathname + windowSearchVal);

			return window.location.href;
		},

		/**
		 * Grabs the parameter in the OpenAnnotate URL based on the microStateKey passed in.
		 * @global
		 * @param {String} microStateKey - The parameter in the URL we want to grab
		 * @return {String}  - the value of the parameter or null if the parameter was not found
		 */
		getParamFromUrlMicrostate: function(microStateKey){
			var windowSearchVal = window.location.search.substring(1);
			var windowSearchVars = windowSearchVal.split('&');
			_.each(windowSearchVars, function(paramName){
				var paramArry = paramName.split('=');
				if(paramArry[0] === microStateKey){
					return paramArry[1];
				}
			}, this)

			return null;
		},

		/**
		 * Passing in the time it took to load a document and what our limits for the fast and medium timed limits are.
		 * @param {int} time - the time it took a document or image too load.
		 * @param {int} timeCompare1 - the limit of time for a fast load
		 * @param {int} timeCompare2 - the limit of time for a medium load
		 * @returns {String} - whichever color correlates with the speed in which the document was loaded.
		*/
		timeColor: function(time, timeCompare1, timeCompare2){
			if(time <= timeCompare1) {
				return '#28a745';
			} else if(time <= timeCompare2) {
				return '#ffc107';
			} else {
				return '#dc3545';
			}
		},

		/**
		 * Updates the url to only have the current mode present, and only present once.
		 */
		removeNonModeURLParameters: function () {
			var url = location.href;
			var modes = ["pageSelectMode", "mode", "redactionMode"];
			modes.forEach(function(mode) {
				var urlparts = url.split('?');  
				// If there are any parameters, look to remove modes. 
				if (urlparts.length >= 2) {
					var prefix = encodeURIComponent(mode)+'=';
					var pars = urlparts[1].split(/[&;]/g);
					// Go over each parameter.
					for (var i = pars.length; i-- > 0;) {	
						if (pars[i].lastIndexOf(prefix, 0) !== -1) {  
							pars.splice(i, 1);
						}
					}

					url = urlparts[0] + '?' + pars.join('&');
				}
			});
			return url;
		},

		/**
		 * Formats the provided date value into the passed in date format.
		 * @global
		 * @param {number} dateToFormat - The UNIX timestamp of the date to format (milliseconds).
		 * @param {String} format - A moment.js date form to use.
		 * @returns {string} - The formatted date according to the passed in date format.
		 */
		dateFormatter: function(dateToFormat, format) {
			// "dateToFormat" is a unix timestamp in milliseconds. 
			// "X" means unix timestamp in seconds so let's divide by 1000.
			var formattedDate = Moment((dateToFormat / 1000), "X").format(format);
			return formattedDate;
		},

		/**
		 * Gets the timestamp string of a given annotations xfdfFields
		 * @global
		 * @param {Object} xfdfFields - The XFDF fields of the annotation.
		 * @param {String} format - A moment.js date form to use.
		 * @param {boolean} showModifiedDate - True if we should display the modified date of the annotation, false if 
		 *                                   	we should show the created date.
		 * @returns {string} - The timestamp string in the "Date (Time Since)" format
		 */
		displayAnnotationTimestamp: function(xfdfFields, format, showModifiedDate) {
			// Check to see if we want to display the modify or created date
			var dateToDisplay;
			var dateLabel;

			if (showModifiedDate) {
				dateToDisplay = xfdfFields.modifyDate;
				dateLabel = LocalizationService.localize("viewer.dialogAnnotation.comment.dateModified");
			}
			else {
				dateToDisplay = xfdfFields.creationDate;
				dateLabel = LocalizationService.localize("viewer.dialogAnnotation.comment.dateCreated");
			}
			
			return dateToDisplay ? dateLabel + this.dateFormatter(dateToDisplay, format) + " (" + Moment(dateToDisplay).fromNow() + ")" : " ";
		},

		/**
		 * Returns all annotations currently on the page
		 * @param {Array} annotationsByPage - An array of pages, each of which contains an array of annotations on
		 * that page.
		 * 
		 * TODO: This probably belongs in the annotation controller.
		 * @global
		 */
		 getAllDocumentAnnotations: function(annotationsByPage){
			var allAnnots = [];
			_.each(annotationsByPage, function (page){
				if (!_.isEmpty(page)){
					_.each(page, function(annot){
						allAnnots.push(annot);
					});
				}
			});
			return allAnnots;
		 },

		/**
		 * Utility function to convert the number of degrees to radians
		 */
		degreesToRadians: function(degrees) {
			return degrees * Math.PI / 180;
		},

		/**
		 * Comapres two floating point numbers with in a certain level of precision.
		 * @global
		 * @param {number} float1 - The first float to compare.
		 * @param {number} float2 - The second float to compare.
		 * @param {number} precision - The number of decimal places to compare to.  Defaults to 1 if not specified.
		 * @returns {boolean} - Whether or not the two floats are equal, to the specified precision.
		 */
		floatEquals: function(float1, float2, precision) {
			// Check args.  If a single float is missing or null, return not equal
			if((!float1 || !float2) && float1 !== float2) {
				return false;
			}
			precision = precision > 0 ? precision : 1;

			// Compare floats at fixed width
			var fixedWideFloat1Str = float1.toFixed(precision);
			var fixedWideFloat2Str = float2.toFixed(precision);
			return fixedWideFloat1Str === fixedWideFloat2Str;
		},

		/**
		 * Do nothing save modification, overridden in extendedUtils.js
		 * @global
		 * @param {Object} saveModificationsOptions - contains values of the type of outstanding changes we want to save.
		 * @param {boolean} hasUnsavedModifications - True if there are currently unsaved modifications on the document, false otherwise.
		 * @param {boolean} hasPageModifications - True if there are outstanding, permanent modifications to PDF Pages, false otherwise.
		 */
		saveModifications: function(){
			var deferred = $.Deferred();
			deferred.resolve();
			return deferred;
		},

		/**
		 * calculates and stores the OC and network times for a network call based on the response headers
		 * 
		 * @global
		 * @param {Object} [options] - An object containing various optional parameters. 
		 * @param {int} [options.startTime] - The start time of the call as a Date.now() (milliseconds)
		 * @param {Object} [options.response] - The jquery response from an ajax call containing the headers the jquery response from an ajax call
		 * @param {String} [options.OCTime] - The key in the timing map for OC Time
		 * @param {String} [options.networkTime] - The key in the timing map for network time
		 * @param {Object} [loadTimingData] - The loadT timing data object to put the 
		 * @return {Object} The updated load timing object.  Modifications are done by reference, so this object is
		 *                     only returned for clarity, the passed-in [loadTimingData] is always modified.
		 */
		calculateRunTimes: function(options, loadTimingData){
			var errorTimingOCCall = false, requestCached = false;
			var totalTime = Date.now() - options.startTime;
			var OCTimeStr = options.response.getResponseHeader("OCCallTime");
			var requestTimestamp = options.response.getResponseHeader("requestTimestamp");
			if (requestTimestamp && requestTimestamp !== options.startTime.toString()) {
				// If these headers don't matchup, we know that this request was cached
				// If the request was cached, our OC time is 0 since we never actually reached OC
				requestCached = true;
				OCTimeStr = "0";
			}
			
			if (OCTimeStr) {
				OCTime = parseFloat(OCTimeStr);
			} else {
				// our timing header is missing, the OC filter must be disabled
				errorTimingOCCall = true;
				OCTime = 0;
			}

			var OCTime = OCTimeStr ? parseFloat(OCTimeStr) : 0;
			var networkTime = totalTime - OCTime;
			loadTimingData[options.OCTime] += OCTime;
			loadTimingData[options.networkTime] += networkTime;

			if (requestCached) {
				loadTimingData.errorsTimingCall[options.OCTime] = "requestCached";
			} else if (errorTimingOCCall) {
				loadTimingData.errorsTimingCall[options.OCTime] = "errorTimingOCCall";
			}

			return loadTimingData;
		},

		/**
		 * Gets the current session section information for the current document if it exists
		 * @param {String} objectId the object id of the current document
		 * @return {Object} the session section information for the current document if it exists
		 */
		getSessionSectionInformation: function(objectId) {
			// Grab the section information for each document from the local storage.
			var sectionProgressInformationArray = window.localStorage.getItem("openAnnotate.sectioningProgressInformation");

			// If we already have our map, parse it.
			sectionProgressInformationArray = JSON.parse(sectionProgressInformationArray);

			// Try to find the current document ID in our local storage array.
			return _.findWhere(sectionProgressInformationArray, {objectId: objectId});
	   },

	   	/**
		 * Helper function to grab the user's initials from their display name
		 * @param {String} displayName - display name of user
		 * @return {String} - the initials of the display name
		 */
		getInitialsFromDisplayName: function(displayName) {
			var splitOnSpace = _S.words(displayName);
			// split on comma and trim whitespace
			var splitOnComma = _S.words(_S.trim(displayName), ',');

			if(splitOnComma.length > 1){
				// assuming we have last,first here
				return _S(splitOnComma[1][0].toUpperCase() + splitOnComma[0][0].toUpperCase()).value();
			}
			else if(splitOnSpace.length > 1){
				// grab first char of first name and first char of lastname
				return _S(splitOnSpace[0][0].toUpperCase() + splitOnSpace[1][0].toUpperCase()).value();
			}
			else {
				// fallback to just using first two chars
				return displayName.substr(0, 2).toUpperCase();
			}
		},

		/**
		 * Converts a string potentially containing a full-width number to a integer parsable string
		 * @param {String} String potentially containing full width numbers
		 * @return {String} The String value of the converted integer
		 */
		convertFullWidthNumber: function (fullWidthNum) {
			if(!fullWidthNum) {
				return fullWidthNum;
			}
			var fullWidthUnicodeOffset = 0xfee0;
			// This will replace all full width numbers with halfwidth numbers
			return fullWidthNum.replace(/[\uFF10-\uFF19]/g, function(c) {
				return String.fromCharCode(c.charCodeAt(0) - fullWidthUnicodeOffset);
			});
		}

	};

	return Utils;
});
